import { ViewStyle } from 'react-native'
import { BoxProps } from './../BoxNew'

const defaultStyle = {
  container: {
    borderColor: '#E1E5E8',
    borderWidth: 1,
    borderRadius: 3,
  } as ViewStyle,
  seperator: {
    borderLeftWidth: 1,
    borderColor: 'GREY_SEPARATOR',
  } as BoxProps,
  tab: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  } as BoxProps,
}

const jpbStyle = {
  container: {} as ViewStyle,
  seperator: {} as BoxProps,
  tab: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
  } as BoxProps,
}
const tabbarType = {
  default: { ...defaultStyle },
  highlights: { ...defaultStyle },
  jpb: { ...jpbStyle },
}

export { tabbarType }
